var map = {
	"./css/dell24.scss": "bad9",
	"./css/variables.module.scss": "4e2f",
	"./fake-data/fake-data-app": "67ab",
	"./fake-data/fake-data-app.json": "67ab",
	"./fake-data/fake-data-form-model-response": "7548",
	"./fake-data/fake-data-form-model-response.json": "7548",
	"./fake-data/images/components/cpu.png": "36bb",
	"./fake-data/images/components/ram.png": "1aa4",
	"./fake-data/images/model-images/power-edge-r340.jpg": "174c",
	"./fake-data/images/producer-logos/dell-logo-shop.png": "39d7",
	"./fake-data/images/producer-logos/dell-logo.svg": "8521",
	"./fake-data/images/test-image.png": "184d",
	"./fonts/helvetica-neue-lt-pro-bold.ttf": "681e",
	"./fonts/helvetica-neue-lt-pro-bold.woff2": "e951",
	"./fonts/helvetica-neue-lt-pro-light.ttf": "7a75",
	"./fonts/helvetica-neue-lt-pro-light.woff2": "16a8",
	"./fonts/helvetica-neue-lt-pro-medium.ttf": "f42a",
	"./fonts/helvetica-neue-lt-pro-medium.woff2": "9b1b",
	"./fonts/helvetica-neue-lt-pro-roman.otf": "1f02",
	"./fonts/helvetica-neue-lt-pro-roman.woff2": "952b",
	"./images/buttons/summary-alert.png": "f99d",
	"./images/buttons/summary-back.png": "7184",
	"./images/buttons/summary-download.png": "c720",
	"./images/buttons/summary-optimization.png": "c4301",
	"./images/buttons/summary-price.png": "c658",
	"./images/buttons/summary-save.png": "dd44",
	"./images/icons/optimization.png": "b81b",
	"./images/icons/phone-call.svg": "e72b",
	"./images/icons/save.png": "dde0",
	"./images/icons/shop.svg": "a631",
	"./images/locales/en.png": "9087",
	"./images/locales/pl.png": "6b0f",
	"./logo.png": "cf05",
	"./no-image.png": "bd21"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";